import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { extractDate } from "../../../Components/Functions/date.fun";
import { useSelector } from "react-redux";
import { capitalizeFirstLetterOfEachWord } from "../../../Components/Functions/word.fun";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcOk } from "react-icons/fc";

const ViewComplatedprojects = () => {
  const user = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/clientProject/getCpById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.cpStatus);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcOk className="fs-2 me-1" />
                  Complete Projects
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Projects</h2>
            </div>
            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Project Id</label>
                  <div className="w-100 col">
                    {(extractDate(id) || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Date of Project
                  </label>
                  <div className="w-100 col">
                    {(extractDate(data?.createdAt) || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Client Name</label>
                  <div className="w-100 col">
                    {(data?.clientName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Client Email</label>
                  <div className="w-100 col">{data?.clientEmail || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Aadhar card Number
                  </label>
                  <div className="w-100 col">
                    {(data?.aadharcardNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Client Contact Number
                  </label>
                  <div className="w-100 col">
                    {(data?.clientContactNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Farm Address</label>
                  <div className="w-100 col">
                    {(data?.farmAddress || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Farm PinCode</label>
                  <div className="w-100 col">
                    {(data?.farmPinCode || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Status</label>
                <div className="w-100 col">
                  <span className=" bg-success text-white"></span>COMPLETED
                </div>
              </div>
              {/* {data && (
                                <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">Notes</label>
                                    <div className="w-100 col">
                                        {data.notes
                                            ? data.notes
                                                .trim()
                                                .split("\n")
                                                .map((line, index) => (
                                                    <span key={index}>
                                                        {line}
                                                        {index !== data.notes.split("\n").length - 1 && (
                                                            <br />
                                                        )}
                                                    </span>
                                                ))
                                            : "N/A"}
                                    </div>
                                </div>
                            )} */}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewComplatedprojects;
